<template>
  <div class="tabs">
    <div class="tab-links-wrapper">
      <slot name="beforeTabLinks"></slot>
      <ul class="tab-links" :class="{ 'flex-column': flexColumn }">
        <li class="mr-6 mb-4" v-for="tab in formattedTabs" :key="tab.slug">
          <a class="hvr-underline-from-left"
            @click="switchTab(tab.label)"
            :class="{'active': (activeTab && tab.slug === activeTab) || ( tab.slug === activeTabWithoutListener) }"
          >{{ tab.label }}</a>
        </li>
    </ul>
    </div>
    <div
      v-for="(tab, index) in formattedTabs"
      :key="index"
      v-show="(activeTab && tab.slug === activeTab) || ( tab.slug === activeTabWithoutListener)"
    >
      <slot :name="tab.label"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    eventbus: {
      type: Boolean,
      default: false
    },
    active: String,
    flexColumn: Boolean
  },
  data () {
    return {
      listenerExists: false,
      activeTabWithoutListener: '',
      formattedTabs: []
    }
  },
  created () {
    if ((this.$listeners && this.$listeners.setActiveTab) || this.eventbus) { this.listenerExists = true }
    this.initTabs()
  },
  methods: {
    initTabs () {
      for (var i = 0; i < this.tabs.length; i += 1) {
        this.formattedTabs.push({
          label: this.tabs[i],
          slug: this.tabs[i].replace(/\s+/g, '-').toLowerCase()
        })
        if (!this.active && !this.listenerExists) { this.activeTabWithoutListener = this.formattedTabs[0].slug }
        if (!this.listenerExists) {
          this.tabs[i] === this.active &&
            (this.activeTabWithoutListener = this.formattedTabs[i].slug)
        }
      }
    },
    switchTab (slug) {
      this.listenerExists
        ? this.eventbus
          ? this.$eventbus.$emit(
            'setActiveTab',
            slug.replace(/\s+/g, '-').toLowerCase()
          )
          : this.$emit('setActiveTab', slug.replace(/\s+/g, '-').toLowerCase())
        : (this.activeTabWithoutListener = slug
          .replace(/\s+/g, '-')
          .toLowerCase())
    }
  },
  computed: {
    activeTab: function () {
      if (this.listenerExists) {
        const obj = this.formattedTabs.find(obj => {
          return obj.slug === this.active
        })
        return obj ? obj.slug : null
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  .tab-links-wrapper {
    display: flex;
  }
  .tab-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    list-style-type: none;
    margin: 0 0 50px -10px;
    padding: 0;
    li {
      margin: 0 10px;
    }
    &.flex-column {
      margin-left: 20px;
      flex-flow: column;
      justify-content: space-between;
    }
  }
}
</style>
